<template>
    <div class="hostStuff tradingView showTabs secondary-color headerTab openHeader sessionExpire">
        <p class="f-16 mb-5 text-center str">Your session is about to expire due to inactivity. Please press Refresh to continue or Logout to close the session</p>
        <div class="sessionExpire-btns fullWidh d-flex align-items-center justify-content-center my-4">
            <button class="btn appButton linkBG justify-content-center" @click="reload()">Refresh</button>
            <button class="btn appButton redBG justify-content-center" @click="logOut()">Logout</button>
        </div>
    </div>
</template>
<script>
import { commonAllmixins } from '@/plugins/commonAll';
import * as types from "@/types";
export default {
    name: 'right-nav',
    mixins: [commonAllmixins],
    data() {
        return {
            chart_type:'',
        }
    },
    methods:{
        reload(){
            window.location.reload();
        },
        logOut() {
            this.$store.dispatch(types.RUN_LOGOUT, {
                globalParams: {},
                localParams: { parameter: this },
            });
        },
    }
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/sidebar-popup/idle-session.vue